import React,{useState,useEffect} from "react";
import ScrollContainer from "react-indiana-drag-scroll";
import Paginator from '../../shared/Paginator';
import NoDataFound from '../../shared/NoDataFound';
import { alphaformatDateTime } from "../../utils/dateFormat";
import { makerCheckerActions } from "../../utils/constants";
import TableLoader from '../../shared/TableLoader';
import config from "../../config";
import api from "../../services/api";
import { Toast } from "../../shared/Toast";
import BrandChecker from "./BrandChecker";


const RejectedRequests = ({data,totalRejected,currentPage,setCurrentPage,handlePageChange,loader,activeRole})=>{
  const [showDrawer,setShowDrawer] = useState(false);
  const [selectedData,setselectedData] = useState();

    return(
        <div>
        <ScrollContainer>
          <table className="table table-bordered">
            <thead>
              <tr className="bg-gray-100">
                <th>Request Sent</th>
                <th>Action type</th>
                <th>Request Date</th>
                <th>Rejected Date</th>
                <th>Rejected Reason</th>
                <th>Action</th>
              </tr>
            </thead>
              {(data.length > 0 && !loader) ? (data.map((row, idx) => {
                const created_at = alphaformatDateTime(row.time);
                const rejected_at = alphaformatDateTime(row.rejected_time)
    
                return (
                <tbody>
                  <tr key={idx} className="border-t">
                    <td>{row.user_name}</td>
                    <td>{makerCheckerActions.find((a) => a.value == row?.action_type)?.label || "-"}</td>
                    <td>
                    <div className='font-bold'>{created_at.dateStr}</div>
                    <div className="text-xs text-gray-500 font-bold">{created_at.timeStr}</div>
                  </td>
                  <td>
                    <div className='font-bold'>{rejected_at.dateStr}</div>
                    <div className="text-xs text-gray-500 font-bold">{rejected_at.timeStr}</div>
                  </td>
                  <td>{row.rej_reason}</td>
                  <td>
                  <button className="bg-blue-600 text-white px-3 py-1 rounded"
                    onClick={()=>{setselectedData(row);setShowDrawer(true)}}>
                    View
                  </button>
                </td>
                  </tr></tbody>
                )
              })) : (!data.length > 0 && !loader ) ? (<NoDataFound colspan="5" />)
            : (<TableLoader colspan="5"/>)}
          </table>
        </ScrollContainer>
        {showDrawer && selectedData && (selectedData?.action_type == 1 || selectedData?.action_type == 2) && <BrandChecker data={selectedData} isfromMail={false} onClose={() => setShowDrawer(false)} isOnlyView={true} />}
        <div className="flex justify-end">
          {Math.ceil(totalRejected / config.PER_PAGE)  > 1 && (
            <Paginator
              pageCount={Math.ceil(totalRejected / config.PER_PAGE)}
              handlePageClick={handlePageChange}
              forcePage={currentPage}
            />)
          }
        </div>
        </div>
    )
}
export default RejectedRequests;